/**
 * @description
 * Capitalizes a sentence
 * @param {String} text Text to be parsed
 */
const capitalize = (text: string): string =>
  text[0].toUpperCase() + text.substring(1).toLowerCase();

export default capitalize;
